module.exports = {"371525001":"清泉街道","371525002":"崇文街道","371525003":"烟庄街道","371525101":"贾镇","371525102":"桑阿镇","371525103":"柳林镇","371525104":"清水镇","371525105":"东古城镇","371525106":"北馆陶镇","371525107":"店子镇","371525108":"定远寨镇","371525109":"辛集镇","371525110":"梁堂镇","371525111":"范寨镇","371525200":"斜店乡","371525205":"甘官屯乡","371525206":"兰沃乡","371525209":"万善乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371525.json
// module id = 1369
// module chunks = 0